export const ActionTypes = {
    SET_ACC: "app/redux/account/SET_ACC",
}